import { createPaginatedSlice } from "../../../helpers/reduxHelper";

const paginatedRooms = createPaginatedSlice('paginatedRooms');

export const paginatedRoomsActions = paginatedRooms.actions
export const paginatedRoomsSelector = state => state.paginatedRooms;
export const paginatedRoomsReducer = paginatedRooms.reducer;
export default paginatedRoomsReducer

export const paginatedRoomsSelectors = paginatedRooms.LF.selectors